(function () {
  var GA4_DESTINATION = 'G-YQ6PP4895M';
  var VIEW_DELAY_MS = 1000;

  function sendEvent(eventName, source) {
    if (!source) return;

    var link = source.matches('a[href]') ? source : source.querySelector('[data-dt-press-link][href]');
    var placement = source.dataset.pressPlacement || '';
    var productHandle = source.dataset.productHandle || '';

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    window.gtag('event', eventName, {
      send_to: GA4_DESTINATION,
      placement: placement,
      publisher: 'the_hindu',
      product_handle: productHandle,
      link_url: link ? link.href : ''
    });
  }

  function isInViewport(element) {
    var rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  }

  function isHalfVisible(element) {
    var rect = element.getBoundingClientRect();
    var visibleWidth = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
    var visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
    var elementArea = rect.width * rect.height;

    return elementArea > 0 && (visibleWidth * visibleHeight) / elementArea >= 0.5;
  }

  function bindPressLinks(root) {
    root.querySelectorAll('[data-dt-press-link]').forEach(function (link) {
      if (link.dataset.pressClickBound === 'true') return;
      link.dataset.pressClickBound = 'true';
      link.addEventListener('click', function () {
        sendEvent('press_proof_click', link);
      });
    });
  }

  function observePressSections(root) {
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var section = entry.target;

        if (section.dataset.pressViewTracked === 'true') {
          observer.unobserve(section);
          return;
        }

        if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && !document.hidden) {
          window.clearTimeout(section.pressViewTimer);
          section.pressViewTimer = window.setTimeout(function () {
            if (section.dataset.pressViewTracked === 'true' || document.hidden || !isHalfVisible(section)) return;
            section.dataset.pressViewTracked = 'true';
            sendEvent('press_proof_view', section);
            observer.unobserve(section);
          }, VIEW_DELAY_MS);
        } else {
          window.clearTimeout(section.pressViewTimer);
        }
      });
    }, { threshold: [0, 0.5] });

    root.querySelectorAll('[data-dt-press-proof]').forEach(function (section) {
      if (section.dataset.pressObserved === 'true') return;
      section.dataset.pressObserved = 'true';
      observer.observe(section);
    });
  }

  function initAnnouncementRotator(root) {
    root.querySelectorAll('[data-dt-announcement-rotator]').forEach(function (rotator) {
      if (rotator.dataset.rotatorReady === 'true') return;

      var messages = Array.prototype.slice.call(rotator.querySelectorAll('[data-dt-announcement-message]'));
      if (messages.length < 2) return;

      rotator.dataset.rotatorReady = 'true';
      var viewTimer;

      function trackHinduView(message) {
        window.clearTimeout(viewTimer);
        if (!message.hasAttribute('data-dt-press-link') || message.dataset.pressViewTracked === 'true') return;

        viewTimer = window.setTimeout(function () {
          if (
            message.classList.contains('is-active') &&
            message.dataset.pressViewTracked !== 'true' &&
            !document.hidden &&
            isInViewport(message)
          ) {
            message.dataset.pressViewTracked = 'true';
            sendEvent('press_proof_view', message);
          }
        }, VIEW_DELAY_MS);
      }

      rotator.addEventListener('dt:announcement-change', function (event) {
        trackHinduView(event.detail);
      });
      trackHinduView(rotator.querySelector('[data-dt-announcement-message].is-active'));
    });
  }

  function init(root) {
    bindPressLinks(root);
    observePressSections(root);
    initAnnouncementRotator(root);
  }

  function initDocument() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDocument);
  } else {
    initDocument();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
